import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { EvidenceBadge } from "@/components/EvidenceBadge";
import { archiveId } from "@/lib/archive";

// Case File card — dossier styling with a deterministic Archive ID and evidence badge.
export function TopicCard({ topic, index = 0, compact = false }) {
  if (!topic) return null;
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4, delay: Math.min(index * 0.03, 0.3), ease: [0.2, 0.8, 0.2, 1] }}
    >
      <Link
        to={`/topic/${topic.slug}`}
        data-testid={`topic-card-${topic.slug}`}
        className="codex-card group relative block h-full p-4 focus:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--codex-focus)]"
      >
        <div className="flex items-center justify-between gap-2">
          <span className="codex-archive-id">{archiveId(topic.slug)}</span>
          <EvidenceBadge level={topic.evidence_level} label={topic.evidence_rating_label} showLabel={false} />
        </div>
        <div className="mt-1 codex-meta-label">{topic.category}</div>
        <h3 className="mt-1.5 font-serif text-lg leading-snug text-foreground transition-colors group-hover:text-gold-light">
          {topic.title}
        </h3>
        {!compact && (
          <p className="mt-1.5 text-sm leading-6 text-muted-foreground line-clamp-3">{topic.summary}</p>
        )}
        <div className="mt-3 flex items-center justify-between">
          {topic.time_period ? (
            <div className="font-mono text-[11px] text-muted-foreground/80">{topic.time_period}</div>
          ) : <span />}
          <span className="inline-flex items-center gap-1 font-mono text-[10px] uppercase tracking-[0.16em] text-gold-soft/70 opacity-0 transition-opacity group-hover:opacity-100">
            Open Case File <ArrowUpRight className="h-3 w-3" />
          </span>
        </div>
      </Link>
    </motion.div>
  );
}
